module.exports = __webpack_public_path__ + "static/about-15c731148210f1743895a440838746fc.jpg";